<nav class="navbar" [class.navbar--scrolled]="isScrolled()" [class.navbar--open]="menu.open()">
  <div class="navbar__inner container">

    <!-- Logo -->
    <a href="/" class="navbar__logo" aria-label="Medicvoy home" (click)="onLogoClick($event)">
      <img src="assets/images/logo.svg" alt="Medicvoy" class="navbar__logo-img" width="107" height="40">
      <span class="navbar__logo-sep" aria-hidden="true">|</span>
      <span class="navbar__logo-sub">DENTAL</span>
    </a>

    <!-- Desktop nav links (hidden on mobile/tablet)
         Excludes About us + Blog — those live in the footer per Pencil design.
         Mobile burger below still shows all 5 items. -->
    <ul class="navbar__links">
      @for (link of desktopNavLinks; track link.path) {
        <li>
          <a
            [routerLink]="link.path"
            routerLinkActive="navbar__link--active"
            class="navbar__link">{{ link.label }}</a>
        </li>
      }
    </ul>

    <!-- Hamburger button (mobile + tablet, hidden on desktop) -->
    <button
      class="navbar__burger"
      (click)="menu.toggle()"
      [attr.aria-expanded]="menu.open()"
      aria-controls="mobile-nav"
      aria-label="Toggle navigation menu">
      <span class="navbar__burger-line"></span>
      <span class="navbar__burger-line"></span>
      <span class="navbar__burger-line"></span>
    </button>

  </div>

  <!-- Overlay menu -->
  <div class="navbar__mobile" id="mobile-nav"
       [class.navbar__mobile--open]="menu.open()"
       (transitionend)="onMobileTransitionEnd($event)">
    <ul class="navbar__mobile-links">
      @for (link of navLinks; track link.path) {
        <li>
          <a [routerLink]="link.path"
             routerLinkActive="navbar__mobile-link--active"
             class="navbar__mobile-link">{{ link.label }}</a>
        </li>
      }
    </ul>
    <a href="#get-a-call" class="navbar__mobile-cta" appQuoteCta="navbar_mobile">
      Get a Free Quote
    </a>
  </div>
</nav>
